import { useContextState } from "../../../../../../../../../../hooks/theme"



const useStyles = () => {
  const { colors } = useContextState()
  return {
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    },
    title: {
      flexGrow: 1,
      fontSize: '20px',//20
      fontWeight: '500',
    },
  }
}

export { useStyles }
